import React, { useState } from "react";
import { Icon, Upload } from "antd";
import { FaFileImport } from "react-icons/fa";
import { toast } from "react-toastify";

import Modal from "../../components/Modal";
import cookies from "../../configs/cookies";
import myConfig from "../../configs/config";

import "antd/dist/antd.css";

function FarmMapKmlImport({ farmId, t, onImported, disabled }) {
  const [isOpen, setIsOpen] = useState(false);
  const { Dragger } = Upload;

  const uploadProps = {
    name: "files",
    multiple: true,
    action: `${myConfig.API_URL}/landplot/${farmId}/import_landplots/`,
    accept: ".kml,.kmz",
    headers: {
      "x-csrftoken": cookies,
      Authorization: `Bearer ${localStorage.getItem("client-token")}`,
    },
    method: "post",
    onChange(info) {
      const { status } = info.file;
      if (status === "done") {
        toast.success(
          t("{{file}} importado com sucesso.", { file: info.file.name }),
          { position: "bottom-right" }
        );
        if (onImported) {
          onImported();
        }
      } else if (status === "error") {
        toast.error(
          t("Falha ao importar {{file}}.", { file: info.file.name }),
          { position: "bottom-right" }
        );
      }
    },
  };

  return (
    <>
      <button
        type="button"
        className="farm-map-page__kml-import-btn"
        onClick={() => setIsOpen(true)}
        disabled={disabled}
        title={t("Importar mapas em KML")}
      >
        <FaFileImport aria-hidden />
        <span>{t("Importar mapas em KML")}</span>
      </button>

      {isOpen ? (
        <Modal
          isModalOpen={isOpen}
          closeModal={() => setIsOpen(false)}
          style={{
            overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
            modal: { width: "min(520px, calc(100% - 32px))" },
          }}
        >
          <h4 style={{ marginTop: 0 }}>{t("Importar mapas em KML")}</h4>
          <p style={{ fontSize: 13, color: "#666" }}>
            {t(
              "Importe polígonos de talhões a partir de arquivos KML ou KMZ para exibir no mapa da fazenda."
            )}
          </p>
          <Dragger
            {...uploadProps}
            style={{ color: "#2e7d32", borderColor: "#81C784" }}
          >
            <p className="ant-upload-drag-icon">
              <Icon type="inbox" style={{ color: "#66BB6A" }} />
            </p>
            <p className="ant-upload-text">
              {t("Clique ou arraste o arquivo para importar")}
            </p>
            <p className="ant-upload-hint">
              {t("Tipos suportados: .kml, .kmz")}
            </p>
          </Dragger>
        </Modal>
      ) : null}
    </>
  );
}

export default FarmMapKmlImport;
